module.exports = __webpack_public_path__ + "media/images/icons/v2/user-01-572f79eed0e20acb80fd76ad199dc1e2.svg";